import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    state: {
        year: 2020,
        token: '',
        acts: [], //JSON.parse( localStorage.getItem( 'acts' ) ),
    },
    mutations: {
        setYear (state, payload) {
            state.year = payload;
            localStorage.setItem( 'acts_year', payload );
        },
		setActs (state, payload) {
            localStorage.setItem( 'acts', JSON.stringify( payload ) );
			state.acts = payload
		},
		setToken (state, payload) {
            //console.log( 111 );
            //console.log( payload );
            localStorage.setItem( 'token', payload );
			state.token = payload
		}
    },
});



// WEBPACK FOOTER //
// ./src/store/store.js